module.exports = __webpack_public_path__ + "img/icon_error03.c813f283.svg";